import React from 'react';
import {
  ResponsiveContainer,
  LineChart as RechartsLineChart,
  BarChart as RechartsBarChart,
  ComposedChart as RechartsComposedChart,
  XAxis as RechartsXAxis,
  YAxis as RechartsYAxis,
  Line as RechartsLine,
  CartesianGrid as RechartsCartesianGrid,
  Tooltip as RechartsTooltip,
  Legend as RechartsLegend,
  Bar as RechartsBar,
  TooltipProps,
} from 'recharts';
import { 
  ChartContainer as ShadcnChartContainer,
  ChartTooltipContent as ShadcnChartTooltipContent,
  ChartTooltip as ShadcnChartTooltip
} from '@/components/ui/chart';

// Re-export recharts components
export const LineChart = RechartsLineChart;
export const BarChart = RechartsBarChart;
export const ComposedChart = RechartsComposedChart;
export const XAxis = RechartsXAxis;
export const YAxis = RechartsYAxis;
export const Line = RechartsLine;
export const CartesianGrid = RechartsCartesianGrid;
export const Tooltip = RechartsTooltip;
export const Legend = RechartsLegend;
export const Bar = RechartsBar;

// Re-export shadcn/ui chart components
export const ChartContainer = ShadcnChartContainer;
export const ChartTooltipContent = ShadcnChartTooltipContent;
export const ChartTooltip = ShadcnChartTooltip;

// Export a custom tooltip component if needed
export const CustomTooltip = ({ 
  active, 
  payload, 
  label, 
  labelFormatter,
  formatter
}: TooltipProps<any, any> & { 
  labelFormatter?: (label: any) => React.ReactNode;
  formatter?: (value: any, name: any, props: any) => React.ReactNode;
}) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-background border border-border rounded-md shadow-md p-3">
        <p className="text-sm font-medium mb-1">
          {labelFormatter ? labelFormatter(label) : label}
        </p>
        {payload.map((entry, index) => (
          <div key={`item-${index}`} className="flex justify-between items-center gap-4">
            <div className="flex items-center gap-1.5">
              <div 
                className="h-2 w-2 rounded-full" 
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-sm text-muted-foreground">{entry.name}:</span>
            </div>
            <span className="text-sm font-medium tabular-nums">
              {formatter ? formatter(entry.value, entry.name, entry) : entry.value}
            </span>
          </div>
        ))}
      </div>
    );
  }

  return null;
};
